module.exports = __webpack_public_path__ + "img/赵戌峰.7098e0a8.jpg";